export function getStyle(element:HTMLElement, propKey: string):string {
  return window.getComputedStyle(element).getPropertyValue(propKey);
}
